// extracted by mini-css-extract-plugin
export var phone = "_44-0";